<template>
  <div>
    <div v-if="!isLocationChange && !isCalendarChange">
      <form class="rent-form">
        <div class="rent-form__part rent-form__part--top" @click="setLocationChange(true, 1)">
          <div class="rent-form__fields">
            <div class="rent-form__field-box">
              <div class="rent-form__field-group" v-if="locationStart && !loading">
                <input type="text" class="form-control rent-form__location" disabled="" :value="`${locationStart.long_name_ru}`">
              </div>
              <div class="rent-form__field-group" v-else v-bind:class="{'rent-form__field-group--skeleton': loading}">
                <input type="text" class="form-control rent-form__location" disabled="" value="Начало аренды">
              </div>
            </div>
          </div>
        </div>
        <div class="rent-form__part rent-form__part--middle" @click="setLocationChange(true, 2)" v-if="locationStart">
          <div class="rent-form__fields">
            <div class="rent-form__field-box">
              <div class="rent-form__field-group" v-if="locationEnd && !loading">
                <input type="text" class="form-control rent-form__location" disabled="" :value="`${locationEnd.long_name_ru}`">
              </div>
              <div class="rent-form__field-group rent-form__field-group--skeleton" v-else>
                <input type="text" class="form-control rent-form__location" disabled="" value="Окончание аренды">
              </div>
            </div>
          </div>
        </div>
        <div class="rent-form__part rent-form__part--middle" v-else>
          <div class="rent-form__fields">
            <div class="rent-form__field-box">
              <div class="rent-form__field-group" v-bind:class="{'rent-form__field-group--skeleton': loading}">
                <input type="text" class="form-control rent-form__location" disabled="" value="Окончание аренды">
              </div>
            </div>
          </div>
        </div>
        <div class="rent-form__group" @click="setCalendarChange(true)">
          <div class="rent-form__part rent-form__part--small">
            <div class="rent-form__fields">
              <div class="rent-form__field-box">
                <div class="rent-form__field-group" v-if="dateStart">
                  <div class="rent-form__datetime">
                    <input class="form-control rent-form__date" :value="dateStart" disabled=""> <span>{{timeStart}}</span>
                  </div>
                </div>
                <div class="rent-form__field-group rent-form__field-group--skeleton  rent-form__field-group--skeleton-mini" v-else>
                  <div class="rent-form__datetime">
                    <input class="form-control rent-form__date" :value="dateStart" disabled=""> <span>{{timeStart}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rent-form__part rent-form__part--small">
            <div class="rent-form__fields">
              <div class="rent-form__field-box">
                <div class="rent-form__field-group" v-if="dateEnd">
                  <div class="rent-form__datetime">
                    <input class="form-control rent-form__date" :value="dateEnd" disabled=""> <span>{{timeEnd}}</span>
                  </div>
                </div>
                <div class="rent-form__field-group rent-form__field-group--skeleton  rent-form__field-group--skeleton-mini" v-else>
                  <div class="rent-form__datetime">
                    <input class="form-control rent-form__date" :value="dateEnd" disabled=""> <span>{{timeEnd}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div v-if="isLocationChange">
      <LocationScreenMob :step="step" />
    </div>
    <div v-if="isCalendarChange">
      <DateScreenMob />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import LocationScreenMob from '@/components/RentForm/LocationScreenMob.vue';
import DateScreenMob from '@/components/RentForm/DateScreenMob.vue';

export default {
    name: 'RentFormMob',
    data() {
      return {
        dateStartField: moment(new Date(), 'DD.MM.YYYY').add(7, 'days').format('DD.MM.YYYY'),
        dateEndField: moment(new Date(), 'DD.MM.YYYY').add(10, 'days').format('DD.MM.YYYY'),
        dateEndTime: '12:00',
        dateStartTime: '12:00',
        locationField: null,
        step: 1,
        loading: true,
      }
    },
    components: {
      LocationScreenMob,
      DateScreenMob,
    },
    computed: {
      isLoading() {
        return this.$store.getters.locationsLoading;
      },
      dateStart() {
        return this.$store.getters.dateStart;
      },
      dateEnd() {
        return this.$store.getters.dateEnd;
      },
      locationStart() {
        return this.$store.getters.locationStart;
      },
      locationEnd() {
        return this.$store.getters.locationEnd;
      },
      timeStart() {
        return this.$store.getters.timeStart;
      },
      timeEnd() {
        return this.$store.getters.timeEnd;
      },
      cars() {
        return this.$store.getters.cars;
      },
      isLocationChange() {
        return this.$store.getters.isLocationChange;
      },
      isCalendarChange() {
        return this.$store.getters.isCalendarChange;
      },
    },
    methods: {
      setLocationChange(status, step) {
        this.$store.dispatch('setLocationChange', status);
        this.step = step;
      },
      setCalendarChange(status) {
        this.$store.dispatch('setCalendarChange', status);
      },
      getDate(date) {
        return moment(date, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY');
      },
      getHour(date) {
        return moment(date, 'DD.MM.YYYY HH:mm:ss').format('HH:mm');
      },
      minDateToday(date) {
        return date < new Date(new Date().setHours(0, 0, 0, 0));
      },
      minDateEnd(date) {
        return date < new Date(moment(this.dateStart, 'DD.MM.YYYY').toDate());
      },
      changeStartDateTime(type) {
        let date = `${this.dateStartField} ${this.dateStartTime}`;
        this.$store.dispatch('changeStartDateTime', date).then(() => {
          this.$router.push({ query: Object.assign({}, this.$route.query, { pick_up_datetime: this.parameters.pick_up_datetime }) });
          if (type == 'time') {
            this.$store.dispatch('getCars').then(() => {
              this.loading = false;
            });
          } else {
            let momentDateStart = moment(this.dateStart, 'DD.MM.YYYY');
            let momentDateEnd = moment(this.dateEnd, 'DD.MM.YYYY');
            if (momentDateStart > momentDateEnd) {
              this.dateEndField = moment(this.dateStart, 'DD.MM.YYYY').add(this.cars.info.rent_period.d, 'days').format('DD.MM.YYYY');
              let date = `${this.dateEndField} ${this.dateEndTime}`;
              this.$store.dispatch('changeEndDateTime', date).then(() => {
                this.$router.push({ query: Object.assign({}, this.$route.query, { drop_off_datetime: this.parameters.drop_off_datetime }) });
                this.$store.dispatch('getCars').then(() => {
                  this.loading = false;
                });
              });
            } else {
              this.$store.dispatch('getCars').then(() => {
                this.loading = false;
              });
            }
          }
        });
      },
      changeEndDateTime() {
        let date = `${this.dateEndField} ${this.dateEndTime}`;
        this.$store.dispatch('changeEndDateTime', date).then(() => {
          this.$router.push({ query: Object.assign({}, this.$route.query, { drop_off_datetime: this.parameters.drop_off_datetime }) });
          this.$store.dispatch('getCars').then(() => {
            this.loading = false;
          });
        });
      },
    },
    mounted() {
      this.$store.dispatch('getCars').then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;        
      })
    },
    watch: {
      dateStart(value) {
        this.dateStartField = value;
      },
      dateEnd(value) {
        this.dateEndField = value;
      },
      timeStart(value) {
        this.dateStartTime = value;
      },
      timeEnd(value) {
        this.dateEndTime = value;
      },
    },
}
</script>

<style>
  .rent-form {
    position: relative;
    z-index: 100;
  }
  .mx-datepicker {
    width: auto !important;
  }
  .mx-icon-calendar, .mx-icon-clear {
    left: -1px;
    color: #000;
    top: 16px;
    font-size: 20px;
    width: 20px;
  }
  @media screen and (min-width: 1000px) {
    .rent-form__date {
      background-image: none !important;
    }
  }
  .rent-form__time+i {
    display: none !important;
  }
  .rent-form__time+i+i {
    display: none !important;
  }
  .rent-form__field-box.disable {
    opacity: 0.5;
    position: relative;
  }
  .rent-form__field-box.disable:after {
    position: absolute;
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  .autocomplete .mx-icon-clear {
    left: auto !important;
    background-color: #fed01f;
  }
  .rent-form__part--middle {
    border-radius: 0 !important;
  }

  @media screen and (min-width: 1000px) {
    .rent-form input {
      -webkit-text-fill-color: #000 !important;
      opacity: 1 !important;
    }
    .mx-table-date td, .mx-table-date th {
      font-size: 14px !important;
    }
  }
  .rent-form__field-group--skeleton {
    position: relative;
  }
  .rent-form__field-group--skeleton:after {
    content: '';
    display: none;
    width: 100%;
    height: 21px;
    position: absolute;
    top: 13px;
    background-color: #e0e0e0;
    width: 76%;
    left: 47px;
    background-size: 600px;
    z-index: 100000;
    background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
    animation: shine-lines 1.6s infinite linear;
  }
  .rent-form__field-group--skeleton-mini:after {
    content: '';
    display: none;
    width: 100%;
    height: 21px;
    position: absolute;
    top: 13px;
    background-color: #e0e0e0;
    width: 80%;
    left: 18%;
    background-size: 600px;
    background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
    animation: shine-lines 1.6s infinite linear;
  }
  
  .is-app .rent-form__field-group--skeleton:after {
    background-color: #e0e0e0;
    display: block;
  }
  .is-app .rent-form__field-group--skeleton-mini:after {
    background-color: #e0e0e0;
    display: block;
  }
  @keyframes shine-lines {
    0% {
      background-position: -100px;
    }
    40%, 100% {
      background-position: 540px;
    }
  }
  @media screen and (max-width: 900px) {
    .rent-form__field-box {
      overflow: hidden;
    }
    .rent-form__part {
      position: relative;
    }
    .rent-form__part--top:after {
      content: '';
      display: block;
      width: 90px;
      height: 97%;
      background: -moz-linear-gradient(left, rgba(254,208,31,0) 0%, rgba(254,208,31,1) 100%);
      background: -webkit-linear-gradient(left, rgba(254,31,255,0) 0%,rgba(254,208,31,1) 100%);
      background: linear-gradient(to right, rgba(254,208,31,0) 0%,rgba(254,208,31,1) 100%);
      position: absolute;
      top: 0;
      right: 0;
    }
    .rent-form__part--middle:after {
      content: '';
      display: block;
      width: 90px;
      height: 97%;
      background: -moz-linear-gradient(left, rgba(254,208,31,0) 0%, rgba(254,208,31,1) 100%);
      background: -webkit-linear-gradient(left, rgba(254,31,255,0) 0%,rgba(254,208,31,1) 100%);
      background: linear-gradient(to right, rgba(254,208,31,0) 0%,rgba(254,208,31,1) 100%);
      position: absolute;
      top: 0;
      right: 0;
    }
    .is-app .rent-form__part--middle:after {
      background: -moz-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(240,240,240,1) 100%);
      background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%,rgba(240,240,240,1) 100%);
      background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(240,240,240,1) 100%);
    }
    .is-app .rent-form__part--top:after {
      background: -moz-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(240,240,240,1) 100%);
      background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%,rgba(240,240,240,1) 100%);
      background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(240,240,240,1) 100%);
    }
    .catalog__categories::-webkit-scrollbar {  
      display: none;
    }  
  }
  .rent-form .form-control:focus {
    border-color: #000 !important;
  }
</style>